import {
	EVENT_ACTION_AUTH_SIGN_OUT,
	EVENT_CATEGORY_AUTH,
	trackCustomEvent,
} from '../../../../../shared/analytics';

export function trackSignOut() {
	trackCustomEvent({
		category: EVENT_CATEGORY_AUTH,
		action: EVENT_ACTION_AUTH_SIGN_OUT,
	});
}
